import "./core/utils/sentry";

import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from "@angular/core";
import {
  PreloadAllModules,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withNavigationErrorHandler,
  withPreloading,
  withRouterConfig,
} from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { provideTranslateService, TranslateLoader } from "@ngx-translate/core";
import * as Sentry from "@sentry/angular";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";
import { provideToastr } from "ngx-toastr";

import { routes } from "./app-routes";
import {
  errorsInterceptor,
  headersInterceptor,
  loaderInterceptor,
  mainInterceptor,
  notificationInterceptor,
} from "./core/interceptors";
import { AdaaHelper, CustomTranslateLoader, handleNavigationError, sentryErrorExtractor } from "./core/utils";
import { Language } from "./shared/constants/enums";
import { AdaaModalService } from "./shared/services";
import { ThemeService } from "./shared/services/theme-service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideAppInitializer(() => void inject(ThemeService)),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "top",
      }),
      withRouterConfig({
        paramsInheritanceStrategy: "always",
        onSameUrlNavigation: "reload",
        urlUpdateStrategy: "eager",
      }),
      withComponentInputBinding(),
      withPreloading(PreloadAllModules),
      withNavigationErrorHandler(handleNavigationError)
    ),
    provideHttpClient(
      withInterceptors([
        mainInterceptor,
        headersInterceptor,
        notificationInterceptor,
        errorsInterceptor,
        loaderInterceptor,
      ])
    ),
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ extractor: sentryErrorExtractor }) },
    { provide: NgbModal, useExisting: AdaaModalService },
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient],
      },
    }),
    provideToastr({
      positionClass: AdaaHelper.getCurrentLang() === Language.Arabic ? "toast-top-left" : "toast-top-right",
    }),
    provideCharts(withDefaultRegisterables()),
  ],
};
